// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1 3H23V21H1V3ZM5 11V13H11V11H5ZM5 15V17H19V15H5ZM16.502 8.6875L19 10.75L19 5L14.0039 5V10.75L16.502 8.6875Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-certificate-filled')
export default class CertificateFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'certificate-filled',
    }
  }
}
